$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
	// logos block slider
	$('.lvp-logos-group').each(function(index, group) {
		$(group).flickity({
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			wrapAround: true
		});
	});
	
});